<template>
	<div>
		<!-- 顶部显示的页面 -->
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
			<el-breadcrumb-item :to="{ path: '/shopManage' }">店铺管理</el-breadcrumb-item>
			<el-breadcrumb-item>员工列表</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 新增套餐的按钮 -->
		<div>
			<el-button type="primary" @click="NewlyAdded">添加员工</el-button>
		</div>
		<div style="margin-top:20px">
			<el-table :data="dataList" v-loading="loading">
				<el-table-column label="姓名" prop="name"/>
				<el-table-column label="手机号" prop="phone"/>
<!--				<el-table-column label="密码" prop="password"/>-->
				<el-table-column label="创建时间" prop="create_date"/>
				<el-table-column label="操作" width="160">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog title="提示" :visible.sync="dialogPop" width="400px">
			<el-form :rules="rules" :model="formList" ref="formList">
				<el-form-item label="姓名" label-width="80px" prop="name">
					<el-input v-model="formList.name" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号" label-width="80px" prop="phone">
					<el-input v-model="formList.phone" placeholder="请输入电话号码" :disabled="editPhone"></el-input>
				</el-form-item>
				<el-form-item label="密码" label-width="80px" prop="password">
					<el-input v-model="formList.password" placeholder="请输入密码"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
    <el-button @click="dialogPop = false">取 消</el-button>
    <el-button type="primary" @click="ok">确 定</el-button>
  </span>
		</el-dialog>
		<!-- 分页 -->
		<div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						   :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
						   layout="total,  prev, pager, next, jumper"
						   :total="total"
						   style="text-align:right;margin:0 16px 10px 0;border-radius:20px"></el-pagination>
		</div>
	</div>
</template>

<script>
import qs from "qs";
import coupon from "../api/coupons";

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			editPhone:false,
			loading:true,
			tableData: [],
			scenicAll: [],
			dialogPop: false,
			currentPage: 1,   //分页
			total: 0,        //分页
			dataList: [],
			editInfo: [],               //商品编辑的数据集合
			rules: {
				name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
				phone: [{required: true, message: '请输入电话号码', trigger: 'blur'}],
				password: [{required: true, message: '请输入密码', trigger: 'blur'}],
			},
			formList: {
				name: '',
				phone: '',
				password: '',
				shop_id: ''
			},
			quaryList: {
				shop_id: undefined,
				count: true,
				pagesize: 10,
				pageindex: 1
			},
			type: 0
		}
	},
	mounted() {
		if (this.$datas.shop.id) {
			this.quaryList.shop_id = this.$datas.shop.id;
			this.getCouponShopEmpList();
		} else {
			this.$router.push({
				path: "/couponPackage"
			});
		}
	},
	methods: {
		// 新增按钮的方法
		NewlyAdded() {
			this.type = 0;
			this.editPhone=false;
			this.formList = {
				name: '',
				phone: '',
				password: '',
				shop_id: ''
			}
			this.dialogPop = true;
		},
		getCouponShopEmpList() {
			this.loading=true;
			coupon.getCouponShopEmpList(this.quaryList).then(res => {
				this.dataList = res.list;
				this.total = res.totalcount;
				this.loading=false;
			}).catch(err=>{
				this.loading=false;
			})
		},
		ok() {
			this.formList.shop_id = this.$datas.shop.id;
			this.$refs.formList.validate((valid) => {
				if (valid) {
					if (this.type === 0) {//添加
						coupon.addCouponShopEmp(this.formList).then(res => {
							this.getCouponShopEmpList();
							this.$message({
								type: 'success',
								showClose: true,
								message: '添加成功!'
							});
						}).catch(err=>{
							this.$message({
								type: 'error',
								showClose: true,
								message: '失败!'
							});
						})
					} else {//修改
						coupon.updateCouponShopEmp(this.formList).then(res => {
							this.getCouponShopEmpList();
							this.$message({
								type: 'success',
								showClose: true,
								message: '修改成功!'
							});
						}).catch(err=>{
							this.$message({
								type: 'error',
								showClose: true,
								message: '失败!'
							});
						})
					}
					this.dialogPop = false;
				}
			})
		},
		// 用户编辑
		edit(row) {
			this.type = 1;
			this.editPhone=true;
			this.formList = row;
			this.dialogPop = true;
		},
		del(row) {//删除
			let id = row.id;
			this.$confirm('确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				coupon.deleteCouponShopEmp(id).then(res => {
					this.getCouponShopEmpList();
					this.$message({
						type: 'success',
						showClose: true,
						message: '删除成功!'
					});
				})
			})
		},
		// 分页
		handleSizeChange(val) {
			this.pageSize = val;
		},
		handleCurrentChange(val) {
			this.currentPage = val;
		},
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/staffList.vue